// extracted by mini-css-extract-plugin
export default {"certificateInput":"environment-saml2-configuration_certificateInput__XU1vC"};